import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { DatabaseService } from './db-service';
import { DocumentReference, Member } from '../models';
import { Gender } from '../enums';

@Injectable({
  providedIn: 'root'
})

export class MemberService {

    public collection: string = 'members';

    constructor(
        private afstore: AngularFirestore,
        private dbservice: DatabaseService) {
    }

    /**
     * Initiate the login process for this user
     * @param churchRef reference of user church
     * @param ageGroup ageGroup that user serve
     */
    public getMembers(churchRef: DocumentReference, ageGroupRef: DocumentReference) {
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('church', '==', churchRef)
            .where('ageGroup', '==', ageGroupRef)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getAllMembers() {
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    // CRUD functions
    // Create
    public async createMember(member: Member) {
        const id = this.afstore.createId();
        this.afstore.collection(this.collection).doc(id).set(member);
        return id;
    }

    public getGenderList = (): any[] => {
        const genderList: any[] = [];
        genderList.push({ name: Gender[Gender.Male], value: Gender.Male });
        genderList.push({ name: Gender[Gender.Female], value: Gender.Female });
        return genderList;
    }
}
